import { graphql } from "gatsby";
import React from "react";

export default function Mieten({ data }) {
  return <></>;
}

export const query = graphql`
  query {
    queryMieten: allSanityMieten(filter: { language: { eq: "en" } }) {
      nodes {
        carousselType
        id
        manuscript {
          asset {
            url
          }
        }
        images {
          asset {
            fluid(maxWidth: 1000) {
              ...GatsbySanityImageFluid
              base64
            }
          }
        }
        place
        _rawText(resolveReferences: { maxDepth: 10 })
        title
      }
    }
    seo: allSanitySeo(
      filter: { language: { eq: "en" }, title: { eq: "Mieten" } }
    ) {
      nodes {
        id
        image {
          asset {
            fluid(maxWidth: 700) {
              ...GatsbySanityImageFluid
              base64
            }
          }
        }
        title
        titlePage
        description
      }
    }
    queryShowHidePlaces: allSanityShowPlacesProgramm {
      nodes {
        klubShowProgramm
        klubShowLocation
        klubShowMieten
        saalShow
        wiengartenShow
        biergartenShow
      }
    }
  }
`;
